module.exports = __webpack_public_path__ + "static/media/41@2x.27734a1c.png";